<template>
   <div
      v-if="visible"
      class="rounded-base flex w-full items-start gap-3 border shadow-sm p-4"
      :class="{
         'bg-red-50 border-red-200': type === 'error',
         'bg-green-50 border-green-200': type === 'success',
         'bg-amber-50 border-amber-200': type === 'warning',
         'bg-white border-light-grey': type === 'info' || !type,
      }"
   >
      <div
         class="flex size-8 shrink-0 items-center justify-center rounded-lg"
         :class="{
            'bg-red-100': type === 'error',
            'bg-green-100': type === 'success',
            'bg-amber-100': type === 'warning',
            'bg-blue-100': type === 'info',
         }"
      >
         <UIcon
            v-if="type === 'warning'"
            name="i-heroicons-exclamation-triangle"
            class="text-warning size-4"
         />
         <UIcon
            v-else-if="type === 'error'"
            name="i-heroicons-exclamation-circle"
            class="text-error size-4"
         />
         <UIcon
            v-else-if="type === 'success'"
            name="i-heroicons-check-circle"
            class="text-success size-4"
         />
         <UIcon
            v-else
            name="i-heroicons-information-circle"
            class="text-primary size-4"
         />
      </div>

      <div class="min-w-0 flex-1">
         <p class="h-s">{{ title }}</p>
         <template v-if="description">
            <div v-if="Array.isArray(description)" class="mt-0.5 flex flex-col gap-0.5">
               <p v-for="(d, i) in description" :key="i" class="p-s text-grey">{{ d }}</p>
            </div>
            <p v-else class="p-s text-grey mt-0.5">{{ description }}</p>
         </template>
      </div>

      <UButton
         v-if="inline"
         icon="i-heroicons-x-mark"
         variant="ghost"
         color="neutral"
         size="xs"
         square
         class="shrink-0"
         @click="visible = false"
      />
   </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

type Props = {
   title: string
   description?: string | string[]
   type?: 'error' | 'success' | 'warning' | 'info'
   inline?: boolean
}

withDefaults(defineProps<Props>(), {
   inline: false,
})

const visible = ref(true)
</script>
